import i18n from "i18next";

import type { ActivityType } from "api/services/treatment/schemas/ScheduleWeek";

export const translateActivityType = (type: ActivityType) => {
  if (type === "exercise") return i18n.t("activities.types.exercise");
  if (type === "lesson") return i18n.t("activities.types.lesson");
  if (type === "functionality") return i18n.t("activities.types.functionality");
  if (type === "report") return i18n.t("activities.types.report");
  if (type === "payment") return i18n.t("activities.types.payment");
  if (type === "activity") return i18n.t("activities.types.activity");
  return type;
};
